<template>
  <div id="">
    <div class="check_btn_box"></div>
    <div class="table-list" v-if="list.length > 0">
      <el-table ref="multipleTable" :data="list" class="table_box" :height="screenHeight">
        <el-table-column :width="88" class-name="all_com" class="qqq">
          <template slot-scope="scope">
            <el-link class="text_blue" :underline="false" :href="`${CardUrl}${scope.row.ID}`" target="_blank">
              <div class="com_box" :class="commodityClass">
                <el-image class="like_img" :src="scope.row.TitImg && scope.row.TitImg != '没有可上传的图片' ? (scope.row.TitImg + $store.state.thumbnail) : '/static/images/noimg.svg'" fit="contain"></el-image>
              </div>
            </el-link>
          </template>
        </el-table-column>
        <el-table-column :label="$t('enum.commodity')" :min-width="200" align="left" class-name="all_com">
          <template slot-scope="scope">
            <el-link class="text_blue" :underline="false" :href="`${CardUrl}${scope.row.ID}`" target="_blank">
              <div class="com_box" :class="commodityClass">
                <p class="color_333 line_txt2">{{ $store.getters.setTitle(scope.row.Title, 'all') }}</p>
              </div>
            </el-link>
          </template>
        </el-table-column>
        <el-table-column :label="$t('enum.buyerOffer')" :width="140" align="right" v-if="showType == 'offer'">
          <template slot-scope="scope">
            <span class="color_333">USD {{ scope.row.USD_BuyPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('enum.myLastOffer')" :width="140" align="right" v-if="showType == 'offer'">
          <template slot-scope="scope">
            <span class="color_333">{{ parseFloat(scope.row.USD_SellPrice) > 0 ? "USD " + scope.row.USD_SellPrice : " —" }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('enum.status')" :width="140" align="center" v-if="showType == 'offer' && tabType == 1">
          <template slot-scope="scope">
            <!-- 状态 未回复 = 0, 已成交 = 1, 拒绝 = 2,拒绝不回复 = 3,失效 = 4 -->
            <span class="color_333">{{ $store.state.OfferStatus[scope.row.Status] }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('enum.timeToReply')" :width="140" align="right" v-if="showType == 'offer'">
          <template slot-scope="scope">
            <!-- 议价倒计时 -->
            <div :class="endingTime(scope.row.FailureTime).indexOf('m') != -1 ? 'color_333' : 'text_red'">
              {{ endingTime(scope.row.FailureTime) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('enum.updateTime')" :width="140" align="right" v-if="showType == 'offer'">
          <template slot-scope="scope">
            <div class="color_333">
              {{ $store.getters.separatedTime(scope.row.FailureTime, 'cut')[0] }}<br />{{ $store.getters.separatedTime(scope.row.FailureTime, 'cut')[1] }}
            </div>
            <!-- <div>{{$store.getters.getTimezone(scope.row.FailureTime)}}</div> -->
            <!-- <div>{{scope.row.FailureTime}}</div> -->
          </template>
        </el-table-column>

        <el-table-column :label="$t('enum.currentBid')" :width="140" align="right" v-if="showType == 'auction' && sType != 'buynow'">
          <template slot-scope="scope">
            <div class="color_333">USD {{ scope.row.USD_Price }}</div>
            <router-link class="underline hover" :to="{ path: '/commodity/Active/VctiveHstory/' + scope.row.ID }">{{ scope.row.AuctionCount }}
              {{ scope.row.AuctionCount != 1 ? $t('enum.bids') : $t('enum.bid') }}
            </router-link>
            <!-- <div class="text_blue">{{scope.row.AuctionCount}} Bids</div> -->
          </template>
        </el-table-column>
        <el-table-column :label="$t('enum.price')" :width="140" align="right" v-if="showType == 'auction' && sType == 'buynow'">
          <template slot-scope="scope">
            <div class="color_333">USD {{ scope.row.USD_Price }}</div>
          </template>
        </el-table-column>

        <el-table-column :label="$t('enum.shippingFee')" :width="140" align="right" v-if="showType == 'auction'">
          <template slot-scope="scope">
            <div class="color_333">
              {{ scope.row.US_PostageMoney != 'Free Shipping' && scope.row.US_PostageMoney != '顺丰到付' ? 'USD' : '' }}
              {{ scope.row.US_PostageMoney == '顺丰到付' ? $t('newItem.payOnDelivery') : scope.row.US_PostageMoney }}
            </div>
            <el-link :underline="false" class="hover underline text_333 free" :data-id="scope.row.ID" @click="ShipmentDetail(scope.row)">
              {{ $t('button.viewDetail') }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column :label="$t('enum.timeLeft')" :width="140" align="right" v-if="showType == 'auction'">
          <template slot-scope="scope">
            <!-- this.$route.name -->
            <!-- {{CardInfo['SRStatus']==2?'Completed':'Rescinded'}} -->
            <div :class="endingTime(scope.row.EffectiveDate).indexOf('h') != -1 ? 'color_333' : 'text_red'">
              {{ endingTime(scope.row.EffectiveDate) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('enum.endingTime')" :width="140" align="right" v-if="showType == 'auction'">
          <template slot-scope="scope">
            <!-- this.$route.name -->
            <!-- {{CardInfo['SRStatus']==2?'Completed':'Rescinded'}} -->
            <div class="color_333">
              {{ $store.getters.separatedTime(scope.row.EffectiveDate, 'cut')[0] }}<br />{{ $store.getters.separatedTime(scope.row.EffectiveDate, 'cut')[1] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('enum.operate')" class-name="all_operate" :width="140" align="center" fixed="right">
          <template slot-scope="scope">
            <div v-if="showType == 'offer'">
              <div class="color_333" @click="OfferBox('Answer', scope.row)" v-if="scope.row.Status == 0" v-show="isAnswer">
                {{ $t('button.reply') }}
              </div>
              <div class="color_333 hover underline" @click="OfferBox('OfferHistory', scope.row)">{{ $t('button.offerHistory') }}</div>
            </div>
            <div v-if="showType == 'auction'">
              <div v-if="$store.getters.applyUnload(scope.row) && $store.getters.canUnload($store.getters.applyUnload(scope.row), scope.row.EffectiveDate)">
                <div class="text_gray" :class="['needApply']" @click="MessageBox('ContNotUnload', scope.row)">
                  <!-- 有竞拍且截标小于1小时 不可下架 -->
                  {{ $t('button.endList') }}
                </div>
              </div>
              <div v-else>
                <div class="color_333 hover underline" :class="[$store.getters.applyUnload(scope.row) ? 'needApply' : 'needNotApply']" @click="MessageBox('Unload', scope.row)">
                  <!-- 有竞拍下架需审核，无竞拍直接下架 -->
                  {{ $t('button.endList') }}
                </div>
              </div>
              <div class="color_333 hover underline" @click="MessageBox('VHistory', scope.row)">{{ $t('button.endListHistory') }}</div>
              <router-link class="underline hover" :to="`/commodity/New?id=${scope.row.ID}&clone=new`">
                <!-- 发布相似 -->
                <span>{{ $t('button.sellSimilar') }}</span>
              </router-link>
              <!-- <el-link class="text_blue" :underline="false" :href="`${CardUrl}${scope.row.ID}`" target="_blank">View Detail</el-link> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else class="no-data">{{ loading ? $t('enum.loading') + "..." : $t('enum.noData') }}</div>
    <dialog-shipment ref="DialogShipment" :ShipmentList="ShipmentList" @DialogSwitch="DialogSwitch"></dialog-shipment>
    <dialog-offer ref="DialogOffer" :OfferTitle="OfferTitle" :OfferList="OfferList" @OfferBox="OfferBox" @DialogSwitch="DialogSwitch">
    </dialog-offer>
  </div>
</template>

<script>
import DialogShipment from '@/components/dialog/dialog-shipment'
import DialogOffer from '@/components/dialog/dialog-offer'
export default {
  name: "watchlistcheck",
  data() {
    return {
      ShipmentShow: false,//DialogShipment
      ShipmentList: [],
      OfferShow: false,//DialogOffer
      OfferList: [],
      OfferTitle: '',
      isAnswer: true,
      lsitwidth: "200",
      commodityClass: "scheduled",
      CardUrl: process.env.VUE_APP_CARD_URL + '/#/carddetails/',
      r_name: '',
      screenHeight: 200,
    };
  },
  props: {
    list: {},
    showType: String,
    sType: String,
    loading: true,
    tabType: Number
  },
  components: { DialogShipment, DialogOffer },
  computed: {
  },
  mounted() {
    let ru_name = this.$route.name
    this.r_name = ru_name
    window.addEventListener('resize', () => {
      this.tabHeight()
    })
    // console.log(this.showType);
  },
  created: function () {
    this.tabHeight()
  },
  methods: {
    // 倒计时
    endingTime(time) {
      let newval = this.$store.getters.setUTC(new Date().getTime(), -8)
      return this.$store.getters.endingTime(newval, '', '', time)
    },
    // 弹框
    MessageBox(val, obj, status) {
      /* Unload UnloadHistory 下架、申请下架、下架历史 */
      let that = this;
      this.$emit("dialogSwitch", val, obj);
    },
    // 获取指定商品运费
    ShipmentDetail(obj) {
      /* Shipment 运费 */
      let that = this;
      that.$get('GetCommodityShipment', `?commodityId=${obj.ID}`)
        .then((res) => {
          console.log("axios-res:", res);

          if (res.result) {
            that.ShipmentList = res.data;
          } else {
            that.ShipmentList = [];
          }
          that.$refs.DialogShipment.ShipmentShow = true;
          that.$refs.DialogShipment.ID = obj.ID;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /* Offer: ToBeAnswered/Answer、 OfferHistory 议价列表 */
    OfferBox(type, obj) {
      let that = this;
      switch (type) {
        case 'Answer'://回答报价
          that.OfferTitle = this.$t('enum.answerOffer');
          that.OfferList = [];
          break;
        case 'OfferHistory'://议价历史
          that.OfferTitle = this.$t('enum.viewOfferHistory');
          // 获取出价历史/商品议价信息
          that.$get('BargainIndex', `?CommodityID=${obj.ID}&memberId=${obj.CreateUser}`, 'BuyerId')
            .then((res) => {
              if (res.result) {
                that.OfferList = res.data;
              } else {
                that.OfferList = [];
              }
            })
            .catch((err) => {
              console.log(err);
            });
          break;
        case 'Accept'://拒绝
          that.OfferList = [];
          that.OfferTitle = this.$t('enum.accept');
          break;
        case 'Decline'://接受
          that.OfferList = [];
          that.OfferTitle = this.$t('enum.decline');
          break;
        case 'NewOffer'://新议价
          that.OfferList = [];
          that.OfferTitle = his.$t('enum.newOffer');
          break;
        default:
          break;
      }
      console.log('CardInfo:', obj);
      that.$refs.DialogOffer.CardInfo = obj;
      that.$refs.DialogOffer.dialogType = type;
      that.$refs.DialogOffer.OfferShow = true;
    },
    // 获取父级getData方法（获取我的商品列表）
    GetDataOffer() {
      this.$parent.getData();//page:offer.vue
    },
    // 物流详情、议价 弹框
    DialogSwitch(dialog) {
      /* dialog Close */
      let that = this;
      switch (dialog) {
        case 'DialogShipment':
          that.$refs.DialogShipment.ShipmentShow = false;
          that.ShipmentList = [];
          break;
        case 'DialogOffer':
          that.$refs.DialogOffer.OfferShow = false;
          that.OfferList = [];
          break;
        default:
          break;
      }
    },
    // 获取高度
    tabHeight() {
      this.screenHeight = document.body.clientHeight;
      let Sheight = this.screenHeight - 70 - 62 - 56 - 25 - 113
      this.$nextTick(() => {
        this.screenHeight = Sheight
      })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/deep/.el-table .cell {
  padding: 0;
}

/deep/.el-table .el-table__cell {
  vertical-align: top;
}

/deep/.el-table .el-table__cell:nth-child(1)>.cell {
  padding: 0;
}

/deep/.el-table .el-table__cell>.cell {
  padding: 0 12px;
}

.table_box {
  width: 100%;
}

.com_box {
  display: flex;
}

.check_btn_box {
  display: flex;
  line-height: 30px;
  padding: 10px 0;
}

.check_btn_box i {
  color: #5f6dae;
  margin-right: 2px;
}

.check_btn {
  padding: 0 12px;
  height: 32px;
  line-height: 30px;
  color: #c8c8c8;
  border-radius: 4px;
  margin-left: 12px;
  border: 1px solid #c8c8c8;
  cursor: pointer;
}

.check_btn.on {
  color: #5f6dae;
  border-color: #5f6dae;
}

.all_operate div {
  cursor: pointer;
}

.all_operate div:hover {}

/deep/.el-table th.el-table__cell>.cell {
  padding: 0 12px;
}

/deep/.el-table th.all_operate>.cell {
  padding: 0 16px;
}

/deep/ .has-gutter {
  height: 48px;
}

>>>.el-table__fixed-right::before {
  height: 0;
}

.free:hover {
  color: #5f6dae;
}
</style>



// WEBPACK FOOTER //
// src/components/tablelist.vue